module.exports = require("js-xdr");